// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"f3052160","787":"7bba26d5"}[chunkId] + ".chunk.js";
};